import { useCallback, useEffect, useRef, useState } from 'react';
import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchItineraryLocations = () => {
  const [loading, setLoading] = useState();
  const [locations, setLocations] = useState([])
  const isMounted = useRef(true)

  const fetchAllLocations = useCallback(async () => {
    setLoading(true);
    if (locations.length === 0) {
        try {
          const response = await lineEndpoint.getLocationsFromOrigin();
          if(response.status === 200) {
            if(isMounted.current) setLocations(response.data)
          }
        } finally {
          setLoading(false);
        }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllLocations().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllLocations]);

  return {
    loading,
    locations,
  };
};
